export const CAMPAIGN_REPORT_NAVIGATE = 'CAMPAIGN_REPORT_NAVIGATE';
export const CAMPAIGN_GET = 'CAMPAIGN_GET';
